/** Extracts the raw Google Ads click ID (`gclid`) from a URL's query string.
 * Unlike Meta's fbc, Google's offline conversion / ClickConversion API expects
 * the raw gclid value (not the wrapped `_gcl_aw` cookie format), so we capture
 * it verbatim. */
export function gclidFromQueryParam(
  inputUrl: string | undefined,
  logger: (message: string, exception: unknown) => void,
): { gclid: string, parsedUrl: URL } | undefined {
  if (!inputUrl?.trim()) { return undefined; }
  try {
    const parsedUrl = new URL(inputUrl);
    const gclid = parsedUrl.searchParams
      .getAll("gclid")
      .find((it) => it.trim())
      ?.trim();
    if (!gclid) { return undefined; }
    return {
      gclid,
      parsedUrl,
    };
  } catch (e) {
    logger("gclidFromQueryParam: failed to parse url", e);
    return undefined;
  }
}
